module.exports = {
  language: {
    name: "中文",
    current: "当前语言"
  },
  //头部蓝色导航栏
  navbar: {
    home: "首页",
    introduction: "论坛介绍",
    schedule: "日程安排",
    signAttend: "参会报名",
    sponsorship: '赞助机会',
    MediaCooperation: "媒体合作",
    lastYearBBS: '上届论坛',
    downloadCenter: '下载中心',
    ContactUs: '联系我们'
  },
  //轮播图按钮
  button: {
    Signspeak: "报名发言",
    Signhearing: "报名听会"
  },
  //首页论坛新闻
  bbsNews: {
    bbsNews: "论坛新闻",
    lookMore: "查看更多 "
  },
  //首页 论坛介绍、赞助机会、举办地点
  column: {
    bbsIntroduced: "论坛介绍",
    sponsorship: '赞助机会',
    held: '举办地点'
  },
  //首页滚动数字
  numberSkip: {
    guestSpeaker: "演讲嘉宾",
    audience: '与会观众',
    country: '国家和地区',
    enterprise: '企业',
    Professional: '专业媒体关注'
  },
  //首页滚动数字
  meeting: {
    meetingAgenda: "会议日程",
    meetingIn: '会议签到',
    mainForum: '主论坛',
    pointsBBS: '分论坛一',
    divideBBS: '分论坛二',
    audienceIn: '听众签到',
    signDesk: '新国展W201会议室听众签到处',
    guestIn: '嘉宾签到',
    guestInDesk: '新国展W201会议室嘉宾签到处',
    lookingForward: '“双碳”目标下煤炭工业的发展路径与展望',
    lookingForwardContent: '共同探讨实现碳达峰、碳中和的目标下。煤炭行业未来发展方向、存在机遇及碳中和的技术措施。总结我国煤矿智能化建设取得的经验，分析我国煤矿智能化发展阶段，政策纸箱、行业标准、关键技术与装备，以及存在的难点问题。',
    application: '煤矿智能化采掘技术装备与应用',
    applicationContent: '煤矿智能化开采关键技术与应用、薄煤层智能化综采承台设备研究、智能化开采、快速掘进、智能掘进、N00工法、充填开采、露天煤矿智能化建设。',
    equipment: '智慧矿山系统与关键技术装备',
    equipmentContent: '5G技术在煤矿业的应用、数字矿山建设、人工智能、大数据、孪生数字技术、煤矿物联网系统、智能洗选、智能通风。',
  },
  //首页演讲嘉宾
  guestSpeaker: {
    guestSpeaker: '演讲嘉宾'
  },
  //首页合作媒体
  mediaParents: {
    mediaParents: '合作媒体'
  },
  //公共尾部
  footer: {
    organizing: '第十九届中国国际煤炭采矿技术交流及设备展览会组委会',
    link: '快速链接',
    exhibition: '我要参展',
    schedule: '展会日程',
    visit: '我要参观',
    website: '展会官网',
    boothFigure: '展位图',
    coalBBS: '煤机论坛',
    wxpublic: '展览会微信公众号',
    scanning: '请扫描二维码进行关注',
    address: '北京市东城区安外大街乙88号中煤大厦',
    unit: '主办单位',
    association: '中国煤炭工业协会',
    assisting: '协办单位',
    energy: '中国中煤能源集团有限公司',
    host: '主办单位',
    coalCompany: '中国煤炭工业国际技术咨询有限责任公司',
    huiShow: '汇显展览有限公司',
    copyright: '版权所有',
    consultingCompany: '中国煤炭工业国际技术咨询有限责任公司',
    support: '技术支持',
    InformationTechnology: '中煤信息技术(北京)有限公司',
  },

  //论坛介绍页面
  BBSInTro: {
    bbsIntro: '论坛介绍',
    paragraphOne: '我国力争2030年前实现碳达峰，2060年前实现碳中和是以习近平同志为核心的党中央经过深思熟虑作出的重大战略决策。实现碳达峰、碳中和，是我国实现可持续发展、高质量发展的内在要求，也是推动构建人类命运共同体的必然学则。对于我国能源结构、产业结构和经济结构转型升级，建设人与自然和谐共生的社会主义现代化强国具有重要战略意义。',
    paragraphTwo: '2020年2月25日，为深入贯彻落实习近平总书记“四个革命、一个合作”能源安全新战略，加快推进煤炭行业供给侧结构性改革，推动智能化技术与煤炭产业融合发展，提升煤矿智能化水平，国家发展改革委、国家能源局、应急部、国家煤矿安监局、工业和信息化部、财政部、科技部、教育部研究制定了《关于加快煤矿智能化发展的指导意见》。煤矿智能化是煤炭工业高质量发展的核心技术支撑，将人工智能、工业互联网、云计算、大数据、机器人、智能装备等与现代煤炭开发利用深度融合，形成全面感知、实时互联、分析决策、自主学习、动态预测、协同控制的智能系统，实现煤矿开拓、采掘（剥）、运输、通风、洗选、安全保障、经营管理等过程额智能化运行，对于提升煤矿安全生产水平、保障煤炭稳定供应具有重要意义。',
    paragraphThree: '科技改变世界，科技铸就未来。技术的变革和装备水平的提升对于“双碳”目标和煤矿智能化的实现将起到重要支撑作用，同时也是我国煤炭行业实现高质量发展的关键所在。第十九届中国国际煤炭采矿技术交流及设备展览会作为我国煤炭行业的盛会，云集了目前国内外在煤矿智能化领域的最先进的领军企业和最先进的技术装备。为共同探讨实现碳达峰、碳中和的目标下，煤炭行业未来发展方向、机遇以及碳中和的技术措施。总结我国煤矿智能化建设方面取得的成就，分析研究我国煤矿智能化建设过程中存在的问题，探讨煤矿智能化未来发展方向，展会组委会决定于第十九届中国国际煤炭采矿技术交流及设备展览会同期举办第二届煤机装备发展现状与展望论坛，本届论坛以煤矿智能化为引领，重点围绕“双碳”目标下的技术措施，煤矿智能化开采和掘进领域、以及智慧矿山建设关键技术与装备、煤炭行业国际合作等方面展开交流讨论。',
  },

  //参会指南页面
  guide: {
    bbsIntro: '参会指南',
    paragraphFirst: '我国力争2030年前实现碳达峰，2060年前实现碳中和是以习近平同志为核心的党中央经过深思熟虑作出的重大战略决策。实现碳达峰、碳中和，是我国实现可持续发展、高质量发展的内在要求，也是推动构建人类命运共同体的必然学则。对于我国能源结构、产业结构和经济结构转型升级，建设人与自然和谐共生的社会主义现代化强国具有重要战略意义。',
    paragraphSecond: '2020年2月25日，为深入贯彻落实习近平总书记“四个革命、一个合作”能源安全新战略，加快推进煤炭行业供给侧结构性改革，推动智能化技术与煤炭产业融合发展，提升煤矿智能化水平，国家发展改革委、国家能源局、应急部、国家煤矿安监局、工业和信息化部、财政部、科技部、教育部研究制定了《关于加快煤矿智能化发展的指导意见》。煤矿智能化是煤炭工业高质量发展的核心技术支撑，将人工智能、工业互联网、云计算、大数据、机器人、智能装备等与现代煤炭开发利用深度融合，形成全面感知、实时互联、分析决策、自主学习、动态预测、协同控制的智能系统，实现煤矿开拓、采掘（剥）、运输、通风、洗选、安全保障、经营管理等过程额智能化运行，对于提升煤矿安全生产水平、保障煤炭稳定供应具有重要意义。',
    paragraphThird: '科技改变世界，科技铸就未来。技术的变革和装备水平的提升对于“双碳”目标和煤矿智能化的实现将起到重要支撑作用，同时也是我国煤炭行业实现高质量发展的关键所在。第十九届中国国际煤炭采矿技术交流及设备展览会作为我国煤炭行业的盛会，云集了目前国内外在煤矿智能化领域的最先进的领军企业和最先进的技术装备。为共同探讨实现碳达峰、碳中和的目标下，煤炭行业未来发展方向、机遇以及碳中和的技术措施。总结我国煤矿智能化建设方面取得的成就，分析研究我国煤矿智能化建设过程中存在的问题，探讨煤矿智能化未来发展方向，展会组委会决定于第十九届中国国际煤炭采矿技术交流及设备展览会同期举办第二届煤机装备发展现状与展望论坛，本届论坛以煤矿智能化为引领，重点围绕“双碳”目标下的技术措施，煤矿智能化开采和掘进领域、以及智慧矿山建设关键技术与装备、煤炭行业国际合作等方面展开交流讨论。',
  },

  //主论坛
  mainForum: {},   //---------------略

  //报名发言
  toSpeak: {
    title: '报名发言',
    abstract: '感谢您对2021中国国际煤炭高峰发展论坛的关注，请您填写好以下信息，点击提交按钮，我们的工作人员将尽快与您联系。本报名发言只是作为预报名，最终以提交的参会申请表为准。点击下载参会申请表',
    companyNameC: '公司名称-中文',
    companyNameE: '公司名称-英文',
    contact: '联系人',
    call: '称呼',
    contactPhoneNumber: '联系人手机号码',
    selectForum: '选择发言论坛',
    selectSponsorship: '选择赞助级别',
    SpeakerName: '发言人姓名',
    SpeakerPosition: '发言人职务',
    yourSubjectC: '发言题目（中文）',
    yourSubjectE: '发言题目（英文）',
    speakAbstractC: '发言内容摘要（中文）',
    speakAbstractE: '发言内容摘要（英文）',

    //报名发言de提示信息
    inputCompanyName: '请输入单位名称',
    inputContactName: '请输入联系人姓名',
    inputPhoneNumber: '请输入联系人手机号码',
    legalPhoneNumber: '请输入合法的手机号！',
    chooseForum: '请选择发言论坛',
    chooselevel: '请选择赞助级别',
    inputLeaderName: '请输入出席领导姓名',
    inputPosition: '请输入发言人职务',
    inputTitle: '请输入发言题目',
    inputAbstract: '请输入发言摘要',
    fillIn: '重新填写',
    sumit: '提交',
    remind: '请填写必填项',

    //报名发言de信息提交成功
    success: {
      successTitle: '报名信息提交成功',
      successContent: '组委会已收到您的报名申请，我们对报名信息进行汇总筛选后，工作人员会以电话形式与您进行信息核准，请保持手机畅通。主办方核准后，将给您发送听会邀请，是否能够听会以组委会邀请为准。',
      sure: '确定',
    },
    //报名发言de信息提交失败------无UI图，暂时忽略
    //  error:{
    //      sure: '确定',
    //  }
  },

  //报名听会
  signUpHearing: {
    title: '报名听会',
    abstract: '感谢您对2021中国国际煤炭高峰发展论坛的关注，即日起至2021年9月30日，通过论坛官网免费报名听会。请您填写好一下信息，点击提交按钮，我们对报名信息进行汇总筛选后，工作人员会以电话形式与您联系，请保持手机畅通。主办方核准后，将给您发送听会邀请，是否能够听会以组委会邀请为准。',
    name: '姓名',
    call: '称呼',
    idType: '证件类型',
    idNumber: '证件号码',
    companyName: '单位名称',
    Address: '通信地址',
    Position: '职务',
    phoneNumber: '手机号码',
    email: 'E-mail',
    boothType: '展位类型',

    //提示信息
    inputName: '请输入姓名',
    inputIdCard: '请输入证件号码',
    authentication: '根据疫情防控要求，所有进入场馆的参会人员均须实名认证。',
    inputCompanyName: '请输入单位名称',
    inputCompanyAddress: '请输入单位地址',
    paperInvitation: '用于接收纸质邀请函',
    inputPosition: '请输入您的职务',
    inputPhoneNumber: '请输入您的手机号码',
    inpuIegalPhoneNumber: '请输入合法的手机号码',
    inputEmailAddress: '请输入您的邮箱地址',
    inpuIegalEmailNumber: '请输入合法的手机号码',
    acceptInvitation: '用于接收电子邀请函',
    PointsThird: '主论坛 | “双碳”目标下煤炭工业的发展路径与展望',
    PointsFirst: '分论坛一 | 煤矿智能化采掘技术装备与应用',
    PointsSecond: '分论坛二 | 智慧矿山系统与关键技术装备',

    sumit: '提交',
    //证件类型下拉框
    idCard: "身份证",
    comeCord: '军官证',
    passport: '护照',
    MacaoPass: '港澳通行证',

    //报名发言de信息提交成功
    success: {
      successTitle: '报名信息提交成功',
      successContent: '您的报名信息已提交展会组委会，工作人员会尽快与您联系，请保持手机号码畅通。',
      sure: '确定',
    },

    //提交失败弹框信息
    error: {
      notice: '提示',
      errorTitle: '报名信息提交失败',
      errorContent: '信息提交失败，请稍后重试',
      errorSure: '知道了 '
    }
  },

  //赞助机会
  sponsorOccasion: {
     title: '2021中国国际煤炭高峰发展论坛赞助方案',
     contactPeople:'联系人',
     contactName:'王应朋',
     contactPhone:'电话',
     TelphoneNumber:'18600660197',

    //A类广告套餐
    firstCategory: {
      title: '1.A类广告套餐',

      name: '名称:',
      nameContent: '主分论坛联合承办单位赞助',

      places: '名额:',
      placesContent: '独家',

      cost: '费用:',
      costContent: '人民币50万元',

      toSpeak: '发言:',
      toSpeakContent: '企业代表进行发言，20分钟',

      txt: '作为联合承办单位，企业名称及公司Logo体现在分论坛主要宣传资料中',

      videoPropaganda: '视频宣传:',
      videoContent: '论坛开幕前以及茶歇期间播放企业宣传片',

      accommodation: '住宿:',
      accommodationContent: '提供3间、2晚嘉宾住宿',

      advertising: '现场广告:',
      advertisingContent: '提供2块现场广告牌，赞助单位提供设计稿',

      catalogue: '会刊广告:',
      catalogueContent: '提供本届展会会刊彩色内页广告1页',

      tea: '茶歇冠名:',
      teaContent: '由联合承办单位冠名赞助论坛茶歇',

      personnelQuota: '参会人员名额:',
      personnelQuotaContent: '10名',

      dinnerSponsored: '晚餐赞助:',
      dinnerSponsoredContent: '由赞助单位提供参会人员10月26日晚餐，具体费用另计。',

    },

    //B类广告套餐
    secondCategory: {
      title: '2.B类广告套餐',

      name: '名称:',
      nameContent: '分论坛联合承办单位赞助',

      places: '名额:',
      placesContent: '每个分论坛各设置一家，共两家',

      cost: '费用:',
      costContent: '人民币30万元',

      toSpeak: '发言:',
      toSpeakContent: {
        first: '（1）主要领导致欢迎词，20分钟',
        second: '（2）主题发言：企业代表进行发言，20分钟',
        third: '（3）主持人：选派会议主持人1名',
      },

      txt: '作为联合承办单位，企业名称及公司Logo体现在分论坛主要宣传资料中',

      videoPropaganda: '视频宣传:',
      videoContent: '论坛开幕前以及茶歇期间播放企业宣传片',

      accommodation: '住宿:',
      accommodationContent: '提供3间、2晚嘉宾住宿',

      advertising: '现场广告:',
      advertisingContent: '提供2块现场广告牌，赞助单位提供设计稿',

      catalogue: '会刊广告:',
      catalogueContent: '提供本届展会会刊彩色内页广告1页',

      tea: '茶歇冠名:',
      teaContent: '由联合承办单位冠名赞助论坛茶歇',

      personnelQuota: '参会人员名额:',
      personnelQuotaContent: '10名',

      dinnerSponsored: '午餐/晚餐赞助:',
      dinnerSponsoredContent: '由赞助单位提供参会人员会议午餐或是晚餐，具体费用另计。',

    },

    //C类广告套餐
    thirdCategory: {
      title: '3.C类广告套餐',

      name: '名称:',
      nameContent: '分论坛企业发言赞助',

      places: '名额:',
      placesContent: '每个分论坛各设置5家，共10家',

      cost: '费用:',
      costContent: '人民币5万元',

      toSpeak: '发言:',
      toSpeakContent: '嘉宾发言20分钟',

      accommodation: '住宿:',
      accommodationContent: '为参会嘉宾提供1间、2晚住宿',

      advertising: '现场广告:',
      advertisingContent: '提供1块现场广告牌，赞助单位提供设计稿',

      catalogue: '会刊广告:',
      catalogueContent: '提供本届展会会刊彩色内页广告1页',

      personnelQuota: '参会人员名额:',
      personnelQuotaContent: '5名',

    },

  },

  //媒体合作
  MediaCooperation: {
    //论坛新闻
    forumNews: {
      title: '论坛新闻',
    },
    //合作媒体
    mediaParents: {
      title: '合作媒体',
      domestic: '国内媒体',
      international: '国际媒体',
    }
  },

  //上届论坛
  lastYear: {
    intro: {
      title: '上届论坛介绍',
      content: ''
    },
    guest: {
      title: '演讲嘉宾',
    },
    agenda: {
      title: '会议议程',
    },
    photo: {
      title: '现场照片',
    },
    data: {
      title: '论坛资料',
      fileName: '文件名称',
      size: '大小',
      operation: '操作'
    },
  },

  //下载中心
  downloadCenter: {
    title: '下载中心',
    fileName: '文件名称',
    size: '大小',
    operation: '操作'
  },

  //联系我们
  contact:{
    contactUs:'联系我们',
    domesticSpeech:'国内演讲嘉宾及听众',
    
    ShiWei:'史   玮',
    ShiWeiPhone:'010-84293557',
    ShiWeiTel:'18600660198',

    WangYingpeng:'王应朋',
    WangYingpengPhone:'010-84293556',
    WangYingpengTel:'18600660197',

    domestic:'chinaminexpo@vip.163.com',
  
    overseasSpeech:'海外演讲嘉宾及听众',
    
    Yinphillips:'尹小菲',
    YinphillipsPhone:'010-84510286',
    YinphillipsTel:'18600660197',
    
    overseas:'zoeyin@together-expo.com.cn'
  




  }
};
